import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SubscriptionCheck = ({ children }) => {
  const [isSubscribed, setIsSubscribed] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkSubscription = async () => {
      try {
        const token = localStorage.getItem('user');
        const response = await fetch('https://api.samasong.com/sama-music/users/get', {
          headers: {
            'Content-Type': 'application/json',
            Authorization: token ? `Bearer ${token}` : ''
          }
        });
        const data = await response.json();
        if (data.success && data.data) {
          setIsSubscribed(data.data.isSubscribed || false);
        }
      } catch (err) {
        console.error('Error checking subscription:', err);
      }
    };

    checkSubscription();
  }, []);

  useEffect(() => {
    if (isSubscribed === false) {
      const timer = setTimeout(() => {
        setShowPopup(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [isSubscribed]);

  const handleGoPremium = () => {
    setShowPopup(false);
    navigate('/premium');
  };

  const handleDismiss = () => {
    setShowPopup(false);
  };

  if (isSubscribed === null) {
    return <>{children}</>;
  }

  return (
    <>
      {children}
      
      {showPopup && !isSubscribed && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
          <div className="bg-slate-900 border border-fuchsia-500/30 rounded-2xl p-6 max-w-sm w-full text-center">
            <div className="w-16 h-16 bg-gradient-to-r from-fuchsia-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-3 5-3v6zm7 0l-5-3 5-3v6z"/>
              </svg>
            </div>
            
            <h2 className="text-xl font-bold text-white mb-2">Upgrade to Premium</h2>
            <p className="text-slate-400 mb-6">
              Unlock unlimited downloads, full analytics, and dedicated support with our premium plans.
            </p>
            
            <div className="space-y-3">
              <button
                onClick={handleGoPremium}
                className="w-full py-3 bg-gradient-to-r from-fuchsia-600 to-purple-600 text-white font-semibold rounded-lg hover:from-fuchsia-700 hover:to-purple-700 transition"
              >
                View Plans
              </button>
              <button
                onClick={handleDismiss}
                className="w-full py-2 text-slate-400 hover:text-white transition text-sm"
              >
                Maybe Later
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SubscriptionCheck;